export const uiText = {
  homeLiveEyebrow: {
    en: "Live",
    es: "En vivo",
    nl: "Live",
    pap: "Na bibo"
  },
  homeLiveTitle: {
    en: "Public sessions, replays, and announcements",
    es: "Sesiones públicas, repeticiones y anuncios",
    nl: "Publieke sessies, herhalingen en aankondigingen",
    pap: "Seshonnan públiko, replaynan i anunsionan"
  },
  homeLiveText: {
    en: "Public sessions, replays, and announcements appear here when ready for study.",
    es: "Las sesiones públicas, repeticiones y anuncios aparecen aquí cuando están listos para el estudio.",
    nl: "Publieke sessies, herhalingen en aankondigingen verschijnen hier wanneer ze klaar zijn voor studie.",
    pap: "Seshonnan públiko, replaynan i anunsionan ta sali aki ora nan ta kla pa estudio."
  },
  homeCourseEyebrow: {
    en: "Course threshold",
    es: "Umbral de cursos",
    nl: "Cursusdrempel",
    pap: "Umbral di kurso"
  },
  homeCourseTitle: {
    en: "Course details",
    es: "Detalles del curso",
    nl: "Cursusdetails",
    pap: "Detayanan di kurso"
  },
  homeCourseText: {
    en: "Choose a course directly, or enter the full Courses index for the complete overview.",
    es: "Elige un curso directamente o entra al índice completo de cursos para ver la visión general.",
    nl: "Kies direct een cursus of open de volledige cursusindex voor het complete overzicht.",
    pap: "Skohe un kurso direktamente òf drenta e índise kompleto di kursonan pa e bista kompleto."
  },
  podcastsSectionText: {
    en: "MP3 podcast episodes are rendered in chronological RSS and public archive order.",
    es: "Los episodios de podcast MP3 se muestran en orden cronológico del RSS y del archivo público.",
    nl: "MP3-podcastafleveringen worden getoond in chronologische RSS- en archiefvolgorde.",
    pap: "Episodionan di podcast MP3 ta wordu mustrá den órden kronológiko di RSS i archivo públiko."
  },
  videosCount: {
    en: "videos",
    es: "videos",
    nl: "video's",
    pap: "videos"
  },
  reserved: {
    en: "reserved",
    es: "reservado",
    nl: "gereserveerd",
    pap: "reservá"
  },
  watchSeason: {
    en: "Watch season",
    es: "Ver temporada",
    nl: "Bekijk seizoen",
    pap: "Wak temporada"
  },
  openReservedSeason: {
    en: "Open reserved season",
    es: "Abrir temporada reservada",
    nl: "Open gereserveerd seizoen",
    pap: "Habri temporada reservá"
  },
  miscCycle: {
    en: "misc cycle",
    es: "ciclo misceláneo",
    nl: "misc-cyclus",
    pap: "siklo miks"
  },
  openCollection: {
    en: "Open collection",
    es: "Abrir colección",
    nl: "Open collectie",
    pap: "Habri kolekshon"
  },
  miscCyclesTitle: {
    en: "Misc cycles",
    es: "Ciclos misceláneos",
    nl: "Misc-cycli",
    pap: "Siklonan miks"
  },
  miscCyclesText: {
    en: "Standalone video collections that sit outside the seven-cycle seasonal structure and remain part of the public video archive.",
    es: "Colecciones de video independientes que están fuera de la estructura estacional de siete ciclos y forman parte del archivo público de videos.",
    nl: "Losstaande videocollecties buiten de seizoensstructuur van zeven cycli, als onderdeel van het publieke videoarchief.",
    pap: "Kolekshonnan di video separá ku ta keda pafó di e struktura di shete siklo i ta parti di e archivo públiko di video."
  },
  sevenCyclesTitle: {
    en: "Seven video cycles",
    es: "Siete ciclos de video",
    nl: "Zeven videocyclus",
    pap: "Shete siklo di video"
  },
  sevenCyclesText: {
    en: "Cycles are named mythologically while preserving their Canon function and sequencing. Cycle 1 is the active foundation cycle.",
    es: "Los ciclos tienen nombres mitológicos y conservan su función y secuencia canónica. El Ciclo 1 es el ciclo fundacional activo.",
    nl: "Cycli dragen mythologische namen en behouden hun canonfunctie en volgorde. Cyclus 1 is de actieve fundamentcyclus.",
    pap: "Siklonan tin nòmber mitológiko i ta preservá nan funshon i órden kanóniko. Siklo 1 ta e siklo di fundamento aktivo."
  },
  noCollectionVideos: {
    en: "No episode videos are bound to this collection yet.",
    es: "Todavía no hay videos de episodios vinculados a esta colección.",
    nl: "Er zijn nog geen afleveringsvideo's aan deze collectie gekoppeld.",
    pap: "Ainda no tin video di episodio konektá na e kolekshon aki."
  },
  noSeasonVideos: {
    en: "This canon season is reserved. No episode videos are bound yet.",
    es: "Esta temporada canónica está reservada. Todavía no hay videos de episodios vinculados.",
    nl: "Dit canonseizoen is gereserveerd. Er zijn nog geen afleveringsvideo's gekoppeld.",
    pap: "E temporada kanóniko aki ta reservá. Ainda no tin video di episodio konektá."
  },
  cloudLibraryTitle: {
    en: "Cloud library",
    es: "Biblioteca en la nube",
    nl: "Cloudbibliotheek",
    pap: "Biblioteka den cloud"
  },
  cloudLibraryText: {
    en: "Google Drive folders are resolved in-page. The Egyptian Texts folder remains disabled until an embed URL is available.",
    es: "Las carpetas de Google Drive se resuelven dentro de la página. La carpeta Egyptian Texts permanece desactivada hasta que haya una URL integrada disponible.",
    nl: "Google Drive-mappen worden in de pagina geopend. De map Egyptian Texts blijft uitgeschakeld totdat een embed-URL beschikbaar is.",
    pap: "Foldernan di Google Drive ta habri den e página. E folder Egyptian Texts ta keda desaktivá te ora un URL integrá ta disponibel."
  },
  noEmbedUrl: {
    en: "No embed URL is available for this folder yet.",
    es: "Todavía no hay una URL integrada disponible para esta carpeta.",
    nl: "Er is nog geen embed-URL beschikbaar voor deze map.",
    pap: "Ainda no tin URL integrá disponibel pa e folder aki."
  },
  searchMaterialsTitle: {
    en: "Search local downloadable materials",
    es: "Buscar materiales descargables locales",
    nl: "Zoek lokale downloadbare materialen",
    pap: "Buska materialnan lokal pa download"
  },
  searchMaterialsText: {
    en: "Search article PDFs and podcast/video study materials available on this site.",
    es: "Busca PDFs de artículos y materiales de estudio de podcasts/videos disponibles en este sitio.",
    nl: "Zoek artikel-PDF's en studiematerialen bij podcasts/video's die op deze site beschikbaar zijn.",
    pap: "Buska PDFnan di artíkulo i materialnan di estudio di podcast/video ku ta disponibel riba e site aki."
  },
  searchFiles: {
    en: "Search files",
    es: "Buscar archivos",
    nl: "Zoek bestanden",
    pap: "Buska failnan"
  },
  searchPlaceholder: {
    en: "Search title, category, file path, or language",
    es: "Buscar título, categoría, ruta de archivo o idioma",
    nl: "Zoek op titel, categorie, bestandspad of taal",
    pap: "Buska título, kategoria, ruta di fail òf idioma"
  },
  localMaterialRecords: {
    en: "local downloadable materials",
    es: "materiales descargables locales",
    nl: "lokale downloadbare materialen",
    pap: "materialnan lokal pa download"
  },
  welcome: {
    en: "Welcome",
    es: "Bienvenido",
    nl: "Welkom",
    pap: "Bon biní"
  },
  getOriented: {
    en: "Get oriented",
    es: "Oriéntate",
    nl: "Oriënteer je",
    pap: "Orientá bo mes"
  },
  getOrientedText: {
    en: "Understand what TGWE is before consuming material.",
    es: "Comprende qué es TGWE antes de consumir material.",
    nl: "Begrijp wat TGWE is voordat je materiaal consumeert.",
    pap: "Komprondé kiko TGWE ta promé ku konsumí material."
  },
  chooseFirstMaterial: {
    en: "Choose first material",
    es: "Elige el primer material",
    nl: "Kies eerste materiaal",
    pap: "Skohe promé material"
  },
  chooseFirstMaterialText: {
    en: "Enter through podcasts, videos, courses, articles, or the library.",
    es: "Entra por podcasts, videos, cursos, artículos o la biblioteca.",
    nl: "Ga binnen via podcasts, video's, cursussen, artikelen of de bibliotheek.",
    pap: "Drenta via podcasts, videos, kursonan, artikulonan òf biblioteka."
  },
  universityChoiceText: {
    en: "Move to the protected study boundary when ready.",
    es: "Pasa al límite protegido de estudio cuando estés listo.",
    nl: "Ga naar de beschermde studiegrens wanneer je klaar bent.",
    pap: "Bai na e frontera protegí di estudio ora bo ta kla."
  },
  orientation: {
    en: "Orientation",
    es: "Orientación",
    nl: "Oriëntatie",
    pap: "Orientashon"
  },
  orientationText: {
    en: "The entry point is reversible: choose, study, return, and reconfigure without losing the public selection state.",
    es: "El punto de entrada es reversible: elige, estudia, vuelve y reconfigura sin perder el estado público de selección.",
    nl: "Het toegangspunt is omkeerbaar: kies, studeer, keer terug en herconfigureer zonder de publieke selectiestaat te verliezen.",
    pap: "E punto di entrada ta reversibel: skohe, studia, bolbe i rekonfigurá sin pèrdè e estado públiko di selekshon."
  },
  readFirst: {
    en: "Read first",
    es: "Leer primero",
    nl: "Lees eerst",
    pap: "Lesa promé"
  },
  readFirstText: {
    en: "Begin with these two texts before moving into podcasts, videos, courses, or the wider article archive.",
    es: "Comienza con estos dos textos antes de pasar a podcasts, videos, cursos o el archivo amplio de artículos.",
    nl: "Begin met deze twee teksten voordat je naar podcasts, video's, cursussen of het bredere artikelarchief gaat.",
    pap: "Kuminsá ku e dos tekstonan aki promé ku pasa pa podcasts, videos, kursonan òf e archivo grandi di artikulonan."
  },
  universityIntro: {
    en: "The University is a separate protected study space. Enter it only when the public orientation and first materials are clear.",
    es: "La Universidad es un espacio de estudio protegido y separado. Entra solo cuando la orientación pública y los primeros materiales estén claros.",
    nl: "De Universiteit is een afzonderlijke beschermde studieruimte. Ga pas naar binnen wanneer de publieke oriëntatie en eerste materialen helder zijn.",
    pap: "Universidat ta un espasio di estudio protegí separá. Drenta solamente ora e orientashon públiko i promé materialnan ta klaro."
  },
  yourHelp: {
    en: "Your help is appreciated.",
    es: "Tu ayuda se aprecia.",
    nl: "Je hulp wordt gewaardeerd.",
    pap: "Bo yudansa ta wordu apresiá."
  },
  donateWith: {
    en: "Donate with",
    es: "Donar con",
    nl: "Doneer met",
    pap: "Doná ku"
  },
  donateWithPayPal: {
    en: "Donate with PayPal",
    es: "Donar con PayPal",
    nl: "Doneer met PayPal",
    pap: "Doná ku PayPal"
  },
  scanOrCopy: {
    en: "Scan the QR code, or copy the address below into your wallet and follow your wallet instructions to make a donation.",
    es: "Escanea el código QR o copia la dirección de abajo en tu billetera y sigue las instrucciones de tu billetera para donar.",
    nl: "Scan de QR-code of kopieer het onderstaande adres naar je wallet en volg de instructies van je wallet om te doneren.",
    pap: "Skèn e kódigo QR, òf kopia e adres aki bou den bo wallet i sigui instrukshonnan di bo wallet pa hasi un donashon."
  },
  copied: {
    en: "Copied",
    es: "Copiado",
    nl: "Gekopieerd",
    pap: "Kopiá"
  },
  copyAddress: {
    en: "Copy address",
    es: "Copiar dirección",
    nl: "Kopieer adres",
    pap: "Kopia adres"
  },
  covenantPrinciple: {
    en: "Covenant principle",
    es: "Principio del pacto",
    nl: "Verbondsprincipe",
    pap: "Prinsipio di paktu"
  },
  anarkhosNetworksTitle: {
    en: "Anarkhos and networks",
    es: "Anarkhos y redes",
    nl: "Anarkhos en netwerken",
    pap: "Anarkhos i retnan"
  },
  anarkhosNetworksText: {
    en: "Books and network memberships are listed separately from public social channels.",
    es: "Los libros y membresías de red se muestran separados de los canales sociales públicos.",
    nl: "Boeken en netwerklidmaatschappen staan apart van publieke sociale kanalen.",
    pap: "Bukinan i membresianan di ret ta listá separá for di kanalnan sosial públiko."
  },
  booksWritten: {
    en: "Books written",
    es: "Libros escritos",
    nl: "Geschreven boeken",
    pap: "Bukinan skibí"
  },
  anarkhosEditionText: {
    en: "The Anarkhos edition follows the active language. Papiamentu resolves to the English edition until a dedicated edition exists.",
    es: "La edición de Anarkhos sigue el idioma activo. Papiamentu dirige a la edición inglesa hasta que exista una edición dedicada.",
    nl: "De Anarkhos-editie volgt de actieve taal. Papiamentu verwijst naar de Engelse editie totdat er een eigen editie bestaat.",
    pap: "E edishon di Anarkhos ta sigui e idioma aktivo. Papiamentu ta bai na e edishon ingles te ora tin un edishon propio."
  },
  networks: {
    en: "Networks",
    es: "Redes",
    nl: "Netwerken",
    pap: "Retnan"
  },
  networksText: {
    en: "Public affiliations and network references connected to the founder profile.",
    es: "Afiliaciones públicas y referencias de red conectadas con el perfil del fundador.",
    nl: "Publieke affiliaties en netwerkverwijzingen verbonden met het oprichtersprofiel.",
    pap: "Afiliashonnan públiko i referensianan di ret konektá ku e perfil di fundadó."
  },
  aboutTgwe: {
    en: "About TGWE",
    es: "Acerca de TGWE",
    nl: "Over TGWE",
    pap: "Tokante TGWE"
  },
  footerAboutText: {
    en: "This show discusses human consciousness, morality, mind control, natural law, the occult, and issues that affect freedom on Earth. The Great Work Experience is a torch of Light in the current darkness of our world and offers practical solutions to the problems we face.",
    es: "Este espacio trata la consciencia humana, la moralidad, el control mental, la ley natural, lo oculto y los asuntos que afectan la libertad en la Tierra. The Great Work Experience es una antorcha de Luz en la oscuridad actual de nuestro mundo y ofrece soluciones prácticas a los problemas que enfrentamos.",
    nl: "Deze uitzending bespreekt menselijk bewustzijn, moraliteit, mind control, natuurwet, het occulte en kwesties die vrijheid op aarde beïnvloeden. The Great Work Experience is een fakkel van Licht in de huidige duisternis van onze wereld en biedt praktische oplossingen voor de problemen waarmee we worden geconfronteerd.",
    pap: "E programa aki ta trata konsenshi humano, moralidat, kontròl mental, lei natural, e okulto i asuntunan ku ta influensia libertat riba Tera. The Great Work Experience ta un flambeu di Lus den e skuridat aktual di nos mundu i ta ofresé solushonnan práktiko pa e problemanan ku nos ta enfrentá."
  },
  quickMenu: {
    en: "Quick Menu",
    es: "Menú rápido",
    nl: "Snelmenu",
    pap: "Menu rápido"
  },
  publicTrust: {
    en: "Public trust",
    es: "Confianza pública",
    nl: "Publiek vertrouwen",
    pap: "Konfiansa públiko"
  },
  followUs: {
    en: "Follow Us",
    es: "Síguenos",
    nl: "Volg ons",
    pap: "Sigui nos"
  },
  books: {
    en: "Books",
    es: "Libros",
    nl: "Boeken",
    pap: "Bukinan"
  },
  footerSeal: {
    en: "Truth rules in 2026\nThis website is made in L.V.X. Dedicated to my friends that came before me.",
    es: "La Verdad rige en 2026\nEste sitio web está hecho en L.V.X. Dedicado a mis amigos que vinieron antes que yo.",
    nl: "Waarheid regeert in 2026\nDeze website is gemaakt in L.V.X. Opgedragen aan mijn vrienden die vóór mij kwamen.",
    pap: "Bèrdat ta regla den 2026\nE wèpsait aki ta trahá den L.V.X. Dediká na mi amigonan ku a bini promé ku mi."
  },
  footerVerse: {
    en: "Thy Word is a lamp unto my feet, and a light unto my path.",
    es: "Tu Palabra es lámpara a mis pies y luz en mi camino.",
    nl: "Uw Woord is een lamp voor mijn voeten en een licht op mijn pad.",
    pap: "Bo Palabra ta un lampi pa mi pianan i un lus pa mi kaminda."
  },
  podcast: {
    en: "Podcast",
    es: "Podcast",
    nl: "Podcast",
    pap: "Podcast"
  },
  video: {
    en: "Video",
    es: "Video",
    nl: "Video",
    pap: "Video"
  },
  media: {
    en: "Media",
    es: "Medios",
    nl: "Media",
    pap: "Media"
  },
  program: {
    en: "Program",
    es: "Programa",
    nl: "Programma",
    pap: "Programa"
  },
  season: {
    en: "Season",
    es: "Temporada",
    nl: "Seizoen",
    pap: "Temporada"
  },
  seasons: {
    en: "Seasons",
    es: "Temporadas",
    nl: "Seizoenen",
    pap: "Temporadanan"
  },
  episode: {
    en: "Episode",
    es: "Episodio",
    nl: "Aflevering",
    pap: "Episodio"
  },
  episodes: {
    en: "Episodes",
    es: "Episodios",
    nl: "Afleveringen",
    pap: "Episodionan"
  },
  language: {
    en: "Language",
    es: "Idioma",
    nl: "Taal",
    pap: "Idioma"
  },
  materials: {
    en: "Materials",
    es: "Materiales",
    nl: "Materialen",
    pap: "Materialnan"
  },
  downloadableItems: {
    en: "Downloadable items attached to this episode.",
    es: "Materiales descargables vinculados a este episodio.",
    nl: "Downloadbare materialen die bij deze aflevering horen.",
    pap: "Materialnan pa download konekta na e episodio aki."
  },
  episodeMaterials: {
    en: "Episode materials",
    es: "Materiales del episodio",
    nl: "Afleveringsmaterialen",
    pap: "Materialnan di episodio"
  },
  materialLinks: {
    en: "material links",
    es: "enlaces de material",
    nl: "materiaallinks",
    pap: "linknan di material"
  },
  noMaterialLinks: {
    en: "No material links are bound yet.",
    es: "Todavía no hay enlaces de material vinculados.",
    nl: "Er zijn nog geen materiaallinks gekoppeld.",
    pap: "Ainda no tin linknan di material konektá."
  },
  openEpisode: {
    en: "Open episode",
    es: "Abrir episodio",
    nl: "Open aflevering",
    pap: "Habri episodio"
  },
  returnToSeason: {
    en: "Return to season",
    es: "Volver a la temporada",
    nl: "Terug naar seizoen",
    pap: "Bai bek na temporada"
  },
  previous: {
    en: "Previous",
    es: "Anterior",
    nl: "Vorige",
    pap: "Anterior"
  },
  next: {
    en: "Next",
    es: "Siguiente",
    nl: "Volgende",
    pap: "Siguiente"
  },
  relatedCourses: {
    en: "Related courses",
    es: "Cursos relacionados",
    nl: "Gerelateerde cursussen",
    pap: "Kursonan relashona"
  },
  relatedArticles: {
    en: "Related articles",
    es: "Articulos relacionados",
    nl: "Gerelateerde artikelen",
    pap: "Artikulonan relashona"
  },
  articleTags: {
    en: "Article tags",
    es: "Etiquetas del articulo",
    nl: "Artikeltags",
    pap: "Etiketnan di artikulo"
  },
  articleBody: {
    en: "Article body",
    es: "Texto del articulo",
    nl: "Artikeltekst",
    pap: "Teksto di artikulo"
  },
  articleDownloads: {
    en: "Article downloads",
    es: "Descargas del articulo",
    nl: "Artikeldownloads",
    pap: "Downloadnan di artikulo"
  },
  articleTextUnavailable: {
    en: "Full public article text is not available in HTML yet. Use the downloads below.",
    es: "El texto completo del articulo todavia no esta disponible en HTML. Usa las descargas de abajo.",
    nl: "De volledige artikeltekst is nog niet beschikbaar in HTML. Gebruik de downloads hieronder.",
    pap: "E teksto kompleto di e artikulo ainda no ta disponibel den HTML. Usa e downloadnan aki bou."
  },
  author: {
    en: "Author",
    es: "Autor",
    nl: "Auteur",
    pap: "Outor"
  },
  date: {
    en: "Date",
    es: "Fecha",
    nl: "Datum",
    pap: "Fecha"
  },
  section: {
    en: "Section",
    es: "Seccion",
    nl: "Sectie",
    pap: "Sekshon"
  },
  routeLanguage: {
    en: "Route language",
    es: "Idioma de la ruta",
    nl: "Routetaal",
    pap: "Idioma di ruta"
  },
  availableArticlePdfs: {
    en: "Available article PDFs",
    es: "PDF de articulo disponibles",
    nl: "Beschikbare artikel-PDF's",
    pap: "PDFnan di artikulo disponibel"
  },
  returnToArticles: {
    en: "Return to articles",
    es: "Volver a articulos",
    nl: "Terug naar artikelen",
    pap: "Bai bek na artikulonan"
  },
  selectedLanguage: {
    en: "Selected language",
    es: "Idioma seleccionado",
    nl: "Geselecteerde taal",
    pap: "Idioma selekta"
  },
  downloadArticlePdf: {
    en: "Download article PDF",
    es: "Descargar PDF del articulo",
    nl: "Download artikel-PDF",
    pap: "Download PDF di artikulo"
  },
  activeLanguagePdfText: {
    en: "Only the active language PDF is shown. If that language is unavailable, English is shown.",
    es: "Solo se muestra el PDF del idioma activo. Si ese idioma no esta disponible, se muestra ingles.",
    nl: "Alleen de PDF van de actieve taal wordt getoond. Als die taal niet beschikbaar is, wordt Engels getoond.",
    pap: "Solamente e PDF di e idioma aktivo ta wordu mustra. Si e idioma ey no ta disponibel, ingles ta wordu mustra."
  },
  relatedPrograms: {
    en: "Related programs",
    es: "Programas relacionados",
    nl: "Gerelateerde programma's",
    pap: "Programanan relashona"
  },
  relatedEpisodes: {
    en: "Related episodes",
    es: "Episodios relacionados",
    nl: "Gerelateerde afleveringen",
    pap: "Episodionan relashona"
  },
  watchVideo: {
    en: "Watch video",
    es: "Ver video",
    nl: "Bekijk video",
    pap: "Wak video"
  },
  fileLabel: {
    en: "File",
    es: "Archivo",
    nl: "Bestand",
    pap: "Fail"
  },
  closePreview: {
    en: "Close preview",
    es: "Cerrar vista previa",
    nl: "Sluit voorbeeld",
    pap: "Sera preview"
  },
  openDownloadSource: {
    en: "Open/download file",
    es: "Abrir/descargar archivo",
    nl: "Open/download bestand",
    pap: "Habri/download fail"
  },
  openRelatedPage: {
    en: "Open related page",
    es: "Abrir página relacionada",
    nl: "Open gerelateerde pagina",
    pap: "Habri página relashoná"
  },
  noMediaUrl: {
    en: "No media URL is bound yet.",
    es: "Todavía no hay una URL multimedia vinculada.",
    nl: "Er is nog geen media-URL gekoppeld.",
    pap: "Ainda no tin URL di media konektá."
  },
  openAudioFile: {
    en: "Open audio file",
    es: "Abrir archivo de audio",
    nl: "Open audiobestand",
    pap: "Habri fail di audio"
  },
  openVideoFile: {
    en: "Open video file",
    es: "Abrir archivo de video",
    nl: "Open videobestand",
    pap: "Habri fail di video"
  },
  mediaNotLoaded: {
    en: "Media is not loaded until you request it.",
    es: "El contenido multimedia no se carga hasta que lo solicites.",
    nl: "Media wordt pas geladen wanneer je daarom vraagt.",
    pap: "Media no ta karga te ora bo pidié."
  },
  loadMedia: {
    en: "Load media",
    es: "Cargar multimedia",
    nl: "Laad media",
    pap: "Karga media"
  },
  openFile: {
    en: "Open file",
    es: "Abrir archivo",
    nl: "Open bestand",
    pap: "Habri fail"
  },
  noPdfLinks: {
    en: "No PDF links are bound yet.",
    es: "Todavía no hay enlaces PDF vinculados.",
    nl: "Er zijn nog geen PDF-links gekoppeld.",
    pap: "Ainda no tin linknan PDF konektá."
  },
  publicCoursesTitle: {
    en: "Public courses",
    es: "Cursos públicos",
    nl: "Publieke cursussen",
    pap: "Kursonan públiko"
  },
  publicCoursesText: {
    en: "These public course cards are available for practice. Text and imagery follow the public course flyers.",
    es: "Estas tarjetas de cursos públicos están disponibles para la práctica. El texto y las imágenes siguen los folletos públicos de los cursos.",
    nl: "Deze publieke cursuskaarten zijn beschikbaar voor oefening. Tekst en beeld volgen de publieke cursusflyers.",
    pap: "E kartanan di kurso públiko aki ta disponibel pa práktika. Teksto i imágen ta sigui e flyernan públiko di kurso."
  },
  accreditationStatement: {
    en: "Accreditation statement",
    es: "Declaración de acreditación",
    nl: "Accreditatieverklaring",
    pap: "Deklarashon di akreditashon"
  },
  readCodeOfMoralConduct: {
    en: "Read the code of moral conduct",
    es: "Leer el código de conducta moral",
    nl: "Lees de code van moreel gedrag",
    pap: "Lesa e kódigo di kondukta moral"
  },
  liveBoundaryActive: {
    en: "The live stream is active. Enter with attention; the light is on.",
    es: "La transmisión en vivo está activa. Entra con atención; la luz está encendida.",
    nl: "De livestream is actief. Ga met aandacht naar binnen; het licht brandt.",
    pap: "E livestream ta aktivo. Drenta ku atenshon; e lus ta sendé."
  },
  liveBoundaryOffline: {
    en: "The live stream is currently offline. When a live event is published, this light turns on.",
    es: "La transmisión en vivo está desconectada. Cuando se publique un evento en vivo, esta luz se enciende.",
    nl: "De livestream is momenteel offline. Wanneer een live-evenement wordt gepubliceerd, gaat dit licht aan.",
    pap: "E livestream ta offline awor. Ora un evento na bibo wordu publiká, e lus aki ta sendé."
  },
  closeLiveStream: {
    en: "Close live stream",
    es: "Cerrar transmisión en vivo",
    nl: "Sluit livestream",
    pap: "Sera livestream"
  },
  noEvents: {
    en: "No events are published.",
    es: "No hay eventos publicados.",
    nl: "Er zijn geen evenementen gepubliceerd.",
    pap: "No tin evento publiká."
  },
  returnHome: {
    en: "Return home",
    es: "Volver al inicio",
    nl: "Terug naar home",
    pap: "Bai kas"
  },
  requestedPath: {
    en: "Requested path",
    es: "Ruta solicitada",
    nl: "Aangevraagd pad",
    pap: "Ruta pidi"
  },
  staticFileBoundary: {
    en: "Static file",
    es: "Archivo estático",
    nl: "Statisch bestand",
    pap: "Fail státiko"
  },
  noReleaseUrl: {
    en: "A public release URL is not available yet.",
    es: "Todavía no hay una URL pública de lanzamiento disponible.",
    nl: "Er is nog geen publieke release-URL beschikbaar.",
    pap: "Ainda no tin URL públiko di lansamentu disponibel."
  },
  notFoundText: {
    en: "This page is not available on the public site.",
    es: "Esta página no está disponible en el sitio público.",
    nl: "Deze pagina is niet beschikbaar op de publieke site.",
    pap: "E página aki no ta disponibel riba e site públiko."
  },
  universityBoundaryText: {
    en: "This path belongs to the existing University. The public site keeps it in its separate protected space.",
    es: "Esta ruta pertenece a la Universidad existente. El sitio público la mantiene en su espacio protegido separado.",
    nl: "Dit pad hoort bij de bestaande Universiteit. De publieke site houdt het in de afzonderlijke beschermde ruimte.",
    pap: "E ruta aki ta pertenesé na e Universidat eksistente. E site públiko ta tene e den su espasio protegí separá."
  },
  staticAssetBoundaryText: {
    en: "This path is a file or verification resource. If it exists, the host serves it directly.",
    es: "Esta ruta es un archivo o recurso de verificación. Si existe, el host lo sirve directamente.",
    nl: "Dit pad is een bestand of verificatiebron. Als het bestaat, serveert de host het rechtstreeks.",
    pap: "E ruta aki ta un fail òf recurso di verifikashon. Si e eksistí, e host ta sirbi e direktamente."
  }
,
  status: { en: "Status", es: "Estado", nl: "Status", pap: "Estado" },
  archetype: { en: "Archetype", es: "Arquetipo", nl: "Archetype", pap: "Arketipo" },
  transformationPurpose: { en: "Transformation purpose", es: "Propósito de transformación", nl: "Transformatiedoel", pap: "Propósito di transformashon" },
  gateway: { en: "Gateway", es: "Portal", nl: "Toegang", pap: "Entrada" },
  seasonMaterials: { en: "Season materials", es: "Materiales de la temporada", nl: "Seizoensmaterialen", pap: "Material di temporada" },
  episodesSection: { en: "Episodes", es: "Episodios", nl: "Afleveringen", pap: "Episodionan" },
  builds: { en: "Builds", es: "Versiones", nl: "Builds", pap: "Versionnan" },
  relatedPaths: { en: "Related paths", es: "Rutas relacionadas", nl: "Verwante paden", pap: "Kamindanan relashoná" },
  returnToProgram: { en: "Return to program", es: "Volver al programa", nl: "Terug naar programma", pap: "Bòlbe na programa" },
  returnToVideos: { en: "Return to Videos", es: "Volver a Videos", nl: "Terug naar Video's", pap: "Bòlbe na Video" },
  collectionLabel: { en: "Collection", es: "Colección", nl: "Verzameling", pap: "Koleksion" },
  cycleLabel: { en: "Cycle", es: "Ciclo", nl: "Cyclus", pap: "Siklo" },
  miscCyclesValue: { en: "Misc cycles", es: "Otros materiales", nl: "Overige media", pap: "Otro media" },
  collectionEpisodes: { en: "Collection episodes", es: "Episodios de la colección", nl: "Verzamelingsafleveringen", pap: "Episodionan di koleksion" },
  seasonEpisodes: { en: "Season episodes", es: "Episodios de la temporada", nl: "Seizoensafleveringen", pap: "Episodionan di temporada" },
  collectionTopic: { en: "Collection topic", es: "Tema de la colección", nl: "Onderwerp van de verzameling", pap: "Tópiko di koleksion" },
  seasonTopic: { en: "Season topic", es: "Tema de la temporada", nl: "Seizoensonderwerp", pap: "Tópiko di temporada" },
  archiveFunction: { en: "Archive function", es: "Función de archivo", nl: "Archieffunctie", pap: "Funshon di archivo" },
  canonMovementLabel: { en: "Canon movement", es: "Movimiento del canon", nl: "Canonbeweging", pap: "Movementu di kanon" },
  relatedPrograms2: { en: "Related programs", es: "Programas relacionados", nl: "Verwante programma's", pap: "Programanan relashoná" },
  canonicalQuestionLabel: { en: "Canonical question", es: "Pregunta canónica", nl: "Canonieke vraag", pap: "Pregunta kanóniko" },
  seasonsIntro: { en: "Explore the seasons that make up this program.", es: "Explora las temporadas que componen este programa.", nl: "Verken de seizoenen waaruit dit programma bestaat.", pap: "Eksplorá e temporadanan ku ta forma e programa aki." },
  episodesOrderNote: { en: "Episodes are listed in their season order.", es: "Los episodios se muestran en el orden de la temporada.", nl: "Afleveringen staan in hun seizoensvolgorde.", pap: "E episodionan ta lista den nan òrden di temporada." },
  typeLabel: { en: "Type", es: "Tipo", nl: "Type", pap: "Tipo" },
  levelLabel: { en: "Level", es: "Nivel", nl: "Niveau", pap: "Nivel" },
  availableLanguages: { en: "Available languages", es: "Idiomas disponibles", nl: "Beschikbare talen", pap: "Idiomanan disponibel" },
  tagsLabel: { en: "Tags", es: "Etiquetas", nl: "Tags", pap: "Etikètnan" },
  categoryLabel: { en: "Category", es: "Categoría", nl: "Categorie", pap: "Kategoria" },
  versionLabel: { en: "Version", es: "Versión", nl: "Versie", pap: "Version" },
  releaseDateLabel: { en: "Release date", es: "Fecha de lanzamiento", nl: "Releasedatum", pap: "Fecha di lansamentu" },
  licenseLabel: { en: "License", es: "Licencia", nl: "Licentie", pap: "Lisensia" },
  courseObjectives: { en: "Course objectives", es: "Objetivos del curso", nl: "Cursusdoelen", pap: "Objetivonan di kurso" },
  topicsLabel: { en: "Topics", es: "Temas", nl: "Onderwerpen", pap: "Tópikonan" },
  methodologyLabel: { en: "Methodology", es: "Metodología", nl: "Methodologie", pap: "Metodologia" },
  courseMaterials: { en: "Course materials", es: "Materiales del curso", nl: "Cursusmateriaal", pap: "Material di kurso" },
  assessmentLabel: { en: "Assessment", es: "Evaluación", nl: "Beoordeling", pap: "Evaluashon" },
  openLink: { en: "Open", es: "Abrir", nl: "Openen", pap: "Habri" },
  statusComingSoon: { en: "Coming soon", es: "Próximamente", nl: "Binnenkort", pap: "Pronto disponibel" },
  catSoftware: { en: "Software", es: "Software", nl: "Software", pap: "Software" },
  catFramework: { en: "Framework", es: "Marco", nl: "Raamwerk", pap: "Struktura" },
  catTool: { en: "Tool", es: "Herramienta", nl: "Hulpmiddel", pap: "Hèrmènt" },
  mediaLanguageNotice: {
    en: "Some original materials are in Dutch or English. Public descriptions and navigation are translated, but podcast audio, video recordings, images, PDFs, and embedded media may remain in their original language.",
    es: "Algunos materiales originales están en neerlandés o inglés. Las descripciones públicas y la navegación están traducidas, pero el audio de los pódcast, las grabaciones de video, las imágenes, los PDF y los medios incrustados pueden permanecer en su idioma original.",
    nl: "Sommige oorspronkelijke materialen zijn in het Nederlands of Engels. De publieke beschrijvingen en navigatie zijn vertaald, maar podcastaudio, video-opnames, afbeeldingen, pdf's en ingesloten media kunnen in hun oorspronkelijke taal blijven.",
    pap: "Algun material original ta na hulandes òf ingles. E deskripshonnan públiko i e navegashon ta tradusí, pero e oudio di podcast, grabashonnan di video, imágennan, PDF i media inkrustá por keda den nan idioma original."
  }
};
